import React, { ReactElement } from 'react';
import clsx from 'clsx';

interface BetaBadgeProps {
  className?: string;
}

const BetaBadge = ({ className }: BetaBadgeProps): ReactElement => {
  return (
    <span
      className={clsx(
        'rounded-full flex justify-center p-0.5 bg-betaBadge text-smallMedium font-medium text-white w-[68px]',
        className
      )}
    >
      BETA
    </span>
  );
};

export default BetaBadge;
